module.exports = __webpack_public_path__ + "media/images/premium/icon-circle-231f6057885a15db7eae56cb6a73a121.svg";